export const setRects = (rects) => {
  return {
      type: "SET_RECTS",
      rects
  }
}